module.exports = ".listado.mat-list .mat-divider {\n  left: 0px !important;\n  width: 100% !important; }\n\n.cancel-button {\n  background-color: #004D40;\n  color: #ffffff;\n  margin: 0 auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/lista-modal/lista-modal.component.scss
// module id = ./src/app/core/components/lista-modal/lista-modal.component.scss
// module chunks = main